import SectionHeading from "@/pages/home/components/SectionHeading";
import { reviewTimeline } from "@/mocks/timeline";

const toneStyles: Record<string, { dot: string; ring: string; tag: string }> = {
  start: { dot: "bg-secondary-500", ring: "bg-secondary-100", tag: "bg-secondary-100 text-secondary-900" },
  rise: { dot: "bg-primary-500", ring: "bg-primary-100", tag: "bg-primary-100 text-primary-800" },
  turn: { dot: "bg-accent-500", ring: "bg-accent-100", tag: "bg-accent-100 text-accent-800" },
  clash: { dot: "bg-accent-500", ring: "bg-accent-100", tag: "bg-accent-100 text-accent-800" },
  cool: { dot: "bg-secondary-500", ring: "bg-secondary-100", tag: "bg-secondary-100 text-secondary-900" },
  end: { dot: "bg-primary-500", ring: "bg-primary-100", tag: "bg-primary-100 text-primary-800" },
};

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-shell mx-auto">
        <SectionHeading
          index="03"
          eyebrow="复盘拆解"
          title="一条事件，六个节点，谁在什么时候改了口"
          desc="按时间顺序拆开看，你会发现很多'突然'其实早有伏笔，很多'反转'只是信息补齐。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 pl-6 md:pl-8">
              {reviewTimeline.map((node) => {
                const tone = toneStyles[node.tone] ?? toneStyles.start;
                return (
                  <li key={node.date} className="relative pb-8 last:pb-0">
                    <span
                      className={`absolute -left-[31px] md:-left-[39px] top-0.5 flex w-6 h-6 items-center justify-center rounded-full ${tone.ring}`}
                    >
                      <span className={`w-2.5 h-2.5 rounded-full ${tone.dot}`} />
                    </span>
                    <div className="flex flex-wrap items-center gap-2.5">
                      <span className="font-heading text-sm font-bold text-foreground-900">
                        {node.date}
                      </span>
                      <span className={`rounded-full px-2.5 py-0.5 text-[11px] ${tone.tag}`}>
                        {node.stage}
                      </span>
                    </div>
                    <h3 className="mt-2.5 font-heading text-base md:text-lg font-bold text-foreground-950">
                      {node.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{node.desc}</p>
                  </li>
                );
              })}
            </ol>
          </div>

          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-24 rounded-lg border border-background-200/80 bg-background-100/50 p-5 md:p-6">
              <div className="flex items-center gap-2 text-xs tracking-[0.2em] text-primary-600">
                <i className="ri-archive-drawer-line" />
                复盘档案
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                本次复盘的三个判断准则
              </h3>
              <ul className="mt-4 space-y-3.5 text-sm text-foreground-600 leading-relaxed">
                <li className="flex gap-2.5">
                  <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" />
                  只采用可回溯到原始出处的材料
                </li>
                <li className="flex gap-2.5">
                  <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" />
                  时间冲突时不消灭证据，而是并列呈现
                </li>
                <li className="flex gap-2.5">
                  <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" />
                  区分事实陈述与立场表达，两者不混用
                </li>
              </ul>
              <a
                href="#insights"
                className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 hover:bg-secondary-600 text-background-50 text-sm font-medium px-4 py-2.5 transition-colors cursor-pointer"
              >
                看具体细节分析
                <i className="ri-arrow-down-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}